import { createAction, createReducer } from '@reduxjs/toolkit';
import toggleBoolean from '../../utils/toggleBoolean.js';

export default function makeDrawerState(name) {
  const OPEN = createAction(`${name}/open`);
  const CLOSE = createAction(`${name}/close`);
  const TOGGLE = createAction(`${name}/toggle`);

  const actions = {
    OPEN,
    CLOSE,
    TOGGLE,
  };

  function openHandler() {
    return true;
  }

  function closeHandler() {
    return false;
  }

  const reducer = createReducer(false, {
    [OPEN]: openHandler,
    [CLOSE]: closeHandler,
    [TOGGLE]: toggleBoolean,
  });

  return { actions, reducer };
}
